<template>
    <BaseSlideOver
        :header-color="'primary'"
        :title="$t(slideOverStore.title)"
        :description="$t(slideOverStore.description ?? '')"
        :size="slideOverStore.size ?? 'md'"
        :model-value="slideOverStore.isSlideOverOpen"
        @update:modelValue="slideOverStore.setSlideOverOpen($event)">
        <Component :is="slideOverComponent"/>
    </BaseSlideOver>
</template>

<script setup lang="ts">
import {useSlideOverStore} from '~/store/slideOver'

const slideOverStore = useSlideOverStore()
const slideOverComponent = computed(() => resolveComponent('SlideOver' + slideOverStore.component))
</script>